// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import releaseStatusEntity from './entities/release-status.json';
import releaseStatusMenu from '../pages/release-status/menu.json';
import releaseStatusFullForm from '../pages/release-status/forms/full.json';
import releaseStatusContextForm from '../pages/release-status/forms/context.json';
import releaseStatusMiniForm from '../pages/release-status/forms/mini.json';
import releaseStatusLookupForm from '../pages/release-status/forms/lookup.json';
import releaseStatusTableView from '../pages/release-status/views/table.json';
import releaseStatusDashboardView from '../pages/release-status/views/dashboard.json';

/** Тип запису «Статус релізу» зі сторінками пакета: меню, форми та подання з pages/release-status/. */
export const releaseStatusDefinition: IRecordTypeDefinition = {
  ...releaseStatusEntity,
  views: assembleViewSet({
      table: releaseStatusTableView,
      dashboard: releaseStatusDashboardView,
  }),
  form: releaseStatusFullForm,
  forms: { full: releaseStatusFullForm, context: releaseStatusContextForm, mini: releaseStatusMiniForm, lookup: releaseStatusLookupForm },
  menu: releaseStatusMenu,
} as IRecordTypeDefinition;
